import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://stars-college-portal-production.up.railway.app/api'
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// AUTH
export const login = (data) => API.post('/auth/login', data);

// ADMIN
export const getStudents = () => API.get('/admin/students');
export const getTeachers = () => API.get('/admin/teachers');
export const addUser = (data) => API.post('/admin/add-user', data);
export const deleteUser = (id) => API.delete(`/admin/delete-user/${id}`);
export const getClasses = () => API.get('/admin/classes');
export const addClass = (data) => API.post('/admin/add-class', data);
export const deleteClass = (id) => API.delete(`/admin/delete-class/${id}`);
export const getSubjects = () => API.get('/admin/subjects');
export const addSubject = (data) => API.post('/admin/add-subject', data);
export const assignStudent = (data) => API.post('/admin/assign-student', data);
export const addNotice = (data) => API.post('/admin/notice', data);
export const getNotices = () => API.get('/admin/notices');
export const addFee = (data) => API.post('/admin/add-fee', data);
export const updateFee = (id, data) => API.put(`/admin/update-fee/${id}`, data);
export const getTeacherRatings = () => API.get('/admin/teacher-ratings');
export const getComplaints = () => API.get('/admin/complaints');
export const replyComplaint = (id, data) => API.put(`/admin/complaint-reply/${id}`, data);
export const addTimetable = (data) => API.post('/admin/timetable', data);
export const getTimetable = () => API.get('/admin/timetable');
export const deleteTimetable = (id) => API.delete(`/admin/timetable/${id}`);

// TEACHER
export const getMySubjects = () => API.get('/teacher/my-subjects');
export const markAttendance = (data) => API.post('/teacher/attendance', data);
export const getAttendance = (id) => API.get(`/teacher/attendance/${id}`);
export const uploadMarks = (data) => API.post('/teacher/marks', data);
export const getMarks = (id) => API.get(`/teacher/marks/${id}`);
export const addAnnouncement = (data) => API.post('/teacher/announcement', data);
export const getTeacherAnnouncements = () => API.get('/teacher/announcements');
export const uploadAssignment = (data) => API.post('/teacher/assignment', data);
export const uploadContent = (data) => API.post('/teacher/content', data);
export const createQuiz = (data) => API.post('/teacher/quiz', data);
export const getMyQuizzes = () => API.get('/teacher/quizzes');
export const updateQuiz = (id, data) => API.put(`/teacher/quiz/${id}`, data);
export const getSubjectStudents = (id) => API.get(`/teacher/students/${id}`);
export const getTeacherTimetable = () => API.get('/teacher/timetable');

// STUDENT
export const getMyProfile = () => API.get('/student/profile');
export const getMyAttendance = () => API.get('/student/attendance');
export const getMyMarks = () => API.get('/student/marks');
export const getMyAnnouncements = () => API.get('/student/announcements');
export const getMyAssignments = () => API.get('/student/assignments');
export const getActiveQuizzes = () => API.get('/student/quizzes');
export const getQuizQuestions = (id) => API.get(`/student/quiz/${id}`);
export const submitQuiz = (data) => API.post('/student/quiz-submit', data);
// Student quiz submit kare
// NAYI (uppercase 'API' — theek)
export const submitQuizAttempt = (data) => API.post('/student/quiz-attempt', data);
export const checkQuizAttempt = (quiz_id) => API.get(`/student/quiz-attempt-check/${quiz_id}`);
export const getQuizResults = (quiz_id) => API.get(`/teacher/quiz-results/${quiz_id}`);
export const getMyFees = () => API.get('/student/fees');
export const submitComplaint = (data) => API.post('/student/complaint', data);
export const getMyComplaints = () => API.get('/student/complaints');
export const rateTeacher = (data) => API.post('/student/rate-teacher', data);
export const getStudentNotices = () => API.get('/student/notices');
export const getSubjectContent = (id) => API.get(`/student/content/${id}`);
export const getStudentTimetable = () => API.get('/student/timetable');
export const getMyReport = () => API.get('/student/my-report');
export const getClassReport = (class_id) => API.get(`/admin/class-report/${class_id}`);
export const getMonthlyReport = (class_id) => API.get(`/admin/monthly-report/${class_id}`);
export const getAllFees = () => API.get('/admin/all-fees');
export const getMyRatings = () => API.get('/student/my-ratings');

// FEE TEMPLATES
export const addFeeTemplate = (data) => API.post('/admin/fee-template', data);
export const getFeeTemplates = () => API.get('/admin/fee-templates');
export const deleteFeeTemplate = (id) => API.delete(`/admin/fee-template/${id}`);
export default API;